// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

import { FacetedContentProductLabelTranslationFragmentDoc } from '../../../../../../domain/product/useFacetedContent.generated';
export const FilterWeddingRingStyleFragmentDoc = `
    fragment filterWeddingRingStyle on CatalogueFilterWeddingRingStylesItem {
  __typename
  label {
    systemCode
    translation(locale: $locale) {
      name
      ...facetedContentProductLabelTranslation
    }
    icon {
      __typename
      id
      url
    }
  }
  totalResults
}
    `;